module.exports = __webpack_public_path__ + "images/FUSA_icons/060-headset.34889609e9198a2f6d7271946fc50f86.svg";